<template>
  <v-app>
    <v-content>
      <submission-form></submission-form>
    </v-content>
  </v-app>
</template>

<script>
import SubmissionForm from "./components/SubmissionForm";
export default {
  name: "App",

  components: {
    SubmissionForm,
  },
};
</script>

